<template>
  <v-card>
    <v-dialog v-model="deleteDialog" max-width="250">
      <action-form
        v-if="deleteDialog"
        :item="deleteItem"
        v-on:close="deleteDialog = false"
        v-on:remove="remove"
      ></action-form>
    </v-dialog>
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>

      <v-btn v-if="!isNew && canDelete" icon @click="remove()">
        <v-icon>mdi-delete</v-icon>
      </v-btn>

      <v-btn icon @click="close()">
        <font-awesome-icon icon="times" size="lg" />
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>

    <slot></slot>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer v-if="showCancel"></v-spacer>
      <v-btn v-if="showCancel" color="primary" text @click="cancel()">{{
        cancelTitle
      }}</v-btn>
      <v-btn
        v-if="showSubmit"
        color="primary"
        :block="!showCancel"
        :dark="canSubmit"
        @click="submit()"
        :disabled="!canSubmit"
        class="px-5"
        >{{ buttonTitle ? buttonTitle : isNew ? "CREATE" : "UPDATE" }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import actionForm from "@/components/action";

export default {
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
    title: String,
    buttonTitle: String,
    deleteItem: String,
    canDelete: {
      type: Boolean,
      default: true,
    },
    canSubmit: {
      type: Boolean,
      default: true,
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    cancelTitle: {
      type: String,
      default: "Cancel",
    },
  },
  components: {
    actionForm,
  },
  data() {
    return {
      deleteDialog: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    cancel() {
      this.$emit("cancel");
    },
    remove() {
      if (this.deleteDialog) {
        this.$emit("remove");
        this.deleteDialog = false;
      } else {
        this.deleteDialog = true;
      }
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>